export const BUILTIN_JUDGE_CRITERIA = [
  {
    id: 'factuality',
    type: 'builtin',
    title: 'Factuality',
    subtitle: 'No hallucinations - only facts from the source',
    enabled: true,
    promptTemplate: null,
  },
  {
    id: 'completeness',
    type: 'builtin',
    title: 'Completeness',
    subtitle: 'Covers the main idea and key details',
    enabled: true,
    promptTemplate: null,
  },
  {
    id: 'conciseness',
    type: 'builtin',
    title: 'Conciseness',
    subtitle: 'No redundancy or fluff',
    enabled: true,
    promptTemplate: null,
  },
  {
    id: 'coherence',
    type: 'builtin',
    title: 'Coherence',
    subtitle: 'Logical flow and readability',
    enabled: true,
    promptTemplate: null,
  },
  {
    id: 'compression',
    type: 'builtin',
    title: 'Compression',
    subtitle: 'Meaning preserved while reducing length',
    enabled: true,
    promptTemplate: null,
  },
];

export const DEFAULT_CUSTOM_PROMPT_TEMPLATE =
  `You are an expert evaluator for text summarisation quality. Evaluate the following summary based on these criteria:
\n1. Factuality (No Hallucinations): The summary contains ONLY information found in the source text.
2. Completeness (Key Information): The summary captures the main idea and critical details.
3. Conciseness (No Redundancy): The summary avoids repetition and unnecessary fluff.
4. Coherence (Flow): The summary is well-structured and easy to read.
5. Compression: The summary meaningfully reduces length while retaining meaning.
\nProvide scores from 0-100 for each criterion and a brief explanation.
\nSource Text: {full_text}
Summary: {summary}
Reference Summary (if available): {reference_summary}`;

